import React, { Component } from 'react';

export class FstyrAlertInfo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: "",
        };
    }
    
    getAlertType(){
        if(this.props.type === "info"){
            return "alert-info"
        }
        else if(this.props.type === "success"){
            return "alert-success"
        }
        else if(this.props.type === "warning"){
            return "alert-warning"
        }
        else if(this.props.type === "error"){
            return "alert-error"
        }
        else{
            return ""
        }
    }

    render() {
        return (
            <div className={"alert " + this.getAlertType()}>
              <div className="alert-body">
                <p className="alert-heading">{this.props.header}</p>
                {this.props.text.map((info, i) => {
                    return(
                        <div style={{ display: 'flex', flexDirection: 'row' }} key={i}>
                            <p style={{ width: '50px' }} className="alert-text">{info.column1}</p>
                            <p className="alert-text">{info.column2}</p>
                        </div>
                    )
                })}
              </div>
            </div>
        );
    }
}